import { expectedAuthTypeQueryParam } from "@/components/Portal/UserAccount/Security/TwoFactorAuthStatus";
import { AuthenticatorBackupCodeConfirm } from "@/components/Welcome/AuthenticatorSetup/AuthenticatorAppConfirm";
import { useQueryParam } from "@/hooks/useQueryParam";
import { portalRoutes } from "@/router/routes/portalRoutes";

export const TwoFactorBackupConfirmView = () => {
  const [expectedAuthType] = useQueryParam(expectedAuthTypeQueryParam);
  const target = expectedAuthType
    ? portalRoutes.user.security.base +
      `?${expectedAuthTypeQueryParam}=${expectedAuthType.toString()}`
    : portalRoutes.user.security.base;

  return (
    <div>
      <AuthenticatorBackupCodeConfirm successTarget={target} />
    </div>
  );
};
